var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.801,
    height: 54.801,
    viewBox: "0 0 54.801 54.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-6{fill:none}.cls-5{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    transform: "rotate(14.98 40.951 16.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_92",
    fill: "#fff",
    stroke: "#f5333f",
    strokeWidth: "2px",
    transform: "rotate(-30 46.84 2.363)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.644,
    cy: 18.644,
    r: 18.644,
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.644,
    cy: 18.644,
    r: 17.644,
    className: "cls-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_91",
    fill: "none",
    stroke: "#f5333f",
    strokeWidth: "2px",
    transform: "rotate(-30 41.747 11.186)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.372,
    cy: 22.372,
    r: 22.372,
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.372,
    cy: 22.372,
    r: 21.372,
    className: "cls-6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_891",
    fill: "#f5333f",
    d: "M0 0H41.5V15.337H0z",
    transform: "rotate(-30 68.878 1.166)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "PAID",
    fill: "#fff",
    fontFamily: "Helvetica",
    fontSize: "12px",
    transform: "rotate(-30 79.398 -43.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.562,
    y: 0
  }, "PAID")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.f938b2bc43a2d8bf7b6d5f4845541929.svg";
export { ForwardRef as ReactComponent };